import { render, staticRenderFns } from "./ViewEmailsModal.vue?vue&type=template&id=2a8f3c80"
import script from "./ViewEmailsModal.vue?vue&type=script&lang=js"
export * from "./ViewEmailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports